import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { cubicInOut } from '../../../utils/transition';

const ANIMATION_DURATION = 1000;

class DonutChart extends Component {
  constructor(props) {
    super(props);
    this.animateSlices = this.animateSlices.bind(this);
    this.slices = [];
  }

  componentDidMount() {
    const { values } = this.props;
    this.animateSlices([], values);
  }

  componentDidUpdate(prevProps) {
    this.animateSlices(prevProps.values, this.props.values);
  }

  animateSlices(fromValues, toValues, duration = ANIMATION_DURATION) {
    if (JSON.stringify(fromValues) === JSON.stringify(toValues)) {
      return;
    }
    let startTime = 0;
    let value;
    const animate = (timestamp) => {
      if (!startTime) {
        startTime = timestamp;
      }
      const t = Math.min(Math.max(timestamp - startTime, 0), duration) / duration;
      let totalOffset = this.props.offset;
      this.slices.forEach((slice, i) => {
        if (!slice) {
          return;
        }
        const from = parseInt(fromValues[i], 10) || 0;
        const to = parseInt(toValues[i], 10) || 0;
        value = (cubicInOut(t) * (to - from)) + from;
        const dashOffset = 100 - totalOffset;
        /* eslint-disable no-param-reassign */
        slice.style.strokeDasharray = `${value} ${100 - value}`;
        slice.style.strokeDashoffset = dashOffset;
        /* eslint-enable no-param-reassign */
        totalOffset += value;
      });
      if (t !== 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }

  render() {
    const { className, values, slicesClassNames, offset } = this.props;
    const spinnerClassNames = classNames('donut-chart', className);
    let totalOffset = offset;
    let sliceKey = 0;
    return (
      <svg className={spinnerClassNames} viewBox="-2 -2 36 36">
        <circle cx="16" cy="16" r="15.91549430918954" className="donut-chart__ring" />

        {values && values.map((v, i) => {
          const sliceClassNames = classNames('donut-chart__slice', slicesClassNames[i]);
          const dashOffset = 100 - totalOffset;
          const style = {
            strokeDasharray: `${v} ${100 - v}`,
            strokeDashoffset: dashOffset
          };
          totalOffset += v;
          sliceKey++;
          return (
            <circle
              key={sliceKey}
              ref={ref => {
                this.slices[i] = ref;
              }}
              className={sliceClassNames}
              cx="16"
              cy="16"
              r="15.91549430918954"
              style={style}
            />
          );
        })}
      </svg>
    );
  }
}

DonutChart.propTypes = {
  className: PropTypes.string,
  values: PropTypes.array,
  slicesClassNames: PropTypes.array,
  offset: PropTypes.number
};

DonutChart.defaultProps = {
  values: [],
  slicesClassNames: ['donut-chart__slice--blue', 'donut-chart__slice--navy'],
  offset: -25
};

export default DonutChart;
